import React from "react";
import {ApiResponse} from "@models/axios";
import {Package} from "./package";
import {PaymentGateway} from "./paymentGateway";
import __i18n from "../intl/__i18n";

export const enum PurchaseStatus {
  "None"    = "none",
  "Pending" = "pending",
  "Success" = "success",
  "Failed"  = "failed"
}


export const PurchaseStatusOptions = [{
  value: PurchaseStatus.None,
  label: __i18n("Not Specified")
},{
  value: PurchaseStatus.Failed,
  label: __i18n("Failed")
},{
  value: PurchaseStatus.Pending,
  label: __i18n("Not Completed"),
}, {
  value: PurchaseStatus.Success,
  label: __i18n("Success")
}];




export interface Purchase extends ApiResponse {
  msisdn: string;
  package_purchase_template:Package,
  package_purchase_template_id: number;
  product_reference_id: string;
  client_reference_id: string;
  status: PurchaseStatus;
  payment_gateway:PaymentGateway;
  used_internal_balance_amount: number;
  package_payment_approach:PaymentApproach;
  package_payment_approach_id:string;
  client_id:String
  id: string;
  created_at: string;
}

export interface PurchaseState {
  readonly loading: boolean;
  readonly data: Purchase[];
  readonly errors?: string;
  readonly count: number
}
